var React = require('react');
var FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
var Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
var FormStore = FuzzyReaction.Stores.FormStore;
var Column = Form.Column;
var Row = Form.Row;

class EditResourceModal extends React.Component {
    /**
	 * Edit subscription form key
	 */
    formKey = 'editSubscription';

    render() {
		return (
			<div className="edit-modal">
				<div className="spacer"></div>
				<div className="row">
					<Form key="editSubscription" formKey={this.formKey}
						bindResource={this.props.resource} >
						<Column grid="sm" size="12">
							<Row>
								<Form.Input fieldKey="label" type="text" label="Susbcription Label" placeholder="Enter Label" limit={120} validations="isLength:4:120" />
							</Row>
							<Row>
								<Form.Input fieldKey="price" type="number" label="Price" placeholder="Enter Price xx.xx" limit={7} validations="isNumeric" />
							</Row>
							<Row>
								<Form.Input fieldKey="sku" type="text" label="SKU" placeholder="Enter SKU" limit={120} validations="isLength:4:120" />
							</Row>
						</Column>
					</Form>
				</div>
			</div>
		)
	}
}

module.exports = EditResourceModal;
